/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ForumSelectSchools.vue?vue&type=template&id=e06e00c0&scoped=true"
import script from "./ForumSelectSchools.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumSelectSchools.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ForumSelectSchools.vue?vue&type=style&index=0&id=e06e00c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06e00c0",
  null
  
)

export default component.exports